export function param () {
  const elementParam = document.querySelectorAll('.param__el');

  elementParam.forEach(element => {
    element.addEventListener('click', (e) => {
      e.preventDefault();

      const attrParam = e.currentTarget.getAttribute('data-setting');

      console.log('changement de page vers ' + attrParam);
    });
  });
}
